<template>
     <div class="invoice-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Invoice" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="invoice-id" 
                type="hidden" 
                v-model="invoice.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Invoice Date:"
                    label-for="invoice-date_invoice"
                    >
                    <b-form-input
                    id="invoice-date_invoice"
                    type="date"
                    v-model="invoice.date_invoice"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <!--b-col md="10" sm="12">
                    <b-form-group 
                            label="Invoice for:" 
                            label-for="invoice-entity_for_invoice">
                        <b-form-input id="invoice-entity_for_invoice" 
                            type="text"
                            v-model="invoice.entity_for_invoice" 
                            size="sm"
                            placeholder="Invoice for..." />
                    </b-form-group>
                </b-col-->
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Invoce for:" 
                        label-for="invoice-entity_id_invoice">
                        <b-select 
                            id="invoice-entity_id_invoice"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="entitys" 
                            v-model="invoice.entity_id_invoice" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Due Date:"
                    label-for="invoice-due_date_invoice"
                    >
                    <b-form-input
                    id="invoice-due_date_invoice"
                    type="date"
                    v-model="invoice.due_date_invoice"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                </b-form-group>
            </b-col>
             <b-col md="3" sm="12">
                    <b-form-group 
                            label="Reference:" 
                            label-for="invoice-reference_invoice">
                        <b-form-input id="invoice-reference_invoice" 
                            type="text"
                            v-model="invoice.reference_invoice" 
                            size="sm"
                            placeholder="Reference..." />
                    </b-form-group>
                    </b-col>
             <b-col md="2" sm="12">
                <b-form-group
                    label="Value:"
                    label-for="invoice-value_invoice"
                >
                    <b-form-input
                        id="invoice-value_invoice"
                        type="number"
                        v-model="invoice.value_invoice"
                        size="sm"
                        step="0.02"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                    />
                </b-form-group>
             </b-col>
             </b-row>
            <b-row>
                 <b-col md="8" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="invoice-comments_invoice">
                        <b-form-textarea id="invoice-comments_invoice"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="invoice.comments_invoice"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>
           
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadInvoices(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                  
                </b-col>
            </b-row>
            <br>
            
        <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <div class="stats">
                <Stat
                    title="Not Received"
                    :value="this.total_plot_open"
                    color="#d54d50"
                />
                <Stat
                    title="Receipt"
                    :value="this.total_plot_closed"
                    color="#3bc480"
                />
                <Stat title="Total" :value="this.total_plot" color="#3282cd" />
            </div>
        </b-row>
        <hr />

             <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Invoice Due Date:"
                    label-for="orderservice-start_date"
                    >
                    <b-form-input
                    id="orderservice-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Invoice Due Date:"
                    label-for="orderservice-end_date"
                    >
                    <b-form-input
                    id="orderservice-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Invoice Situation">
                    <b-form-radio-group
                        size="lg"
                        v-model="receipt"
                        @input="loadInvoices"
                        :options="optionsReceipt"
                        name="orderservice-receipt"
                    ></b-form-radio-group>  
                    </b-form-group>    
                </b-col>
             </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                     <b-col md="8" sm="12">
                        <b-form-group >
                            <b-form-input id="invoice-entity_for_invoice" 
                                type="text"
                                v-model="search" 
                                size="sm"
                                placeholder="Search by Invoice for..." />
                        </b-form-group>
                    </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.receipt_date_invoice"
                        title = "Receipt" 
                        size="sm" 
                        variant="light" 
                        @click="[openModalReceipt(data.item)]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>          
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadInvoice(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadInvoice(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadInvoice(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                      <b-button
                        title = "Attachment Invoice"
                        size="sm"
                        @click="setInvoice(data.item)"
                        variant="light"
                        class="mr-2 mt-2 fa fa-plus"
                        v-b-modal.modalFile
                        > 
                    </b-button>
                    <b-button
                        title="View File"
                        size="sm"
                        variant="light"
                        v-if="data.item.storage_id_invoice > 0"
                        @click="loadUrl(data.item)"
                        class="mr-2 mt-2"
                    >
                    <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
         <b-modal
            id="modalReceipt"
            ref="modal"
            title-tag="h6"
            title="Receipt"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="showMsgBoxReceipt"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Receipt Date:"
                            label-for="invoice-receipt_date_invoice"
                        >
                            <b-form-input
                                id="invoice-receipt_date_invoice"
                                type="date"
                                v-model="invoice.receipt_date_invoice"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="5" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="invoice.bank_deposit_invoice"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="invoice-bank_deposit_invoice"
                                />
                                <label
                                    class="form-check-label"
                                    for="invoice-bank_deposit_invoice"
                                >
                                    Bank Deposit?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
         </b-modal> 
        <b-modal
        id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>   
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Stat from '../home/Stat'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'InvoiceSearch',
    components: {PageTitle,Stat },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                invoice: {},
                owners:[],
                invoices: [],
                invoicecontracts:[],
                entitys: [],
                perPage: 20,
                currentPage: 1,
                total_plot_closed: 0,
                total_plot_open: 0,
                total_plot: 0,
                 isBusy: false,
                 showTable: false,
                 start_date: null,
                 end_date: null,
                 receipt: null,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {key: 'date_invoice',label: 'Invoice Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'entity_for_invoice', label: 'Invoive for', sortable: false ,variant: 'light'},
                    { key: 'reference_invoice', label: 'Reference', sortable: false ,variant: 'light'},
                    {key: 'due_date_invoice',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'value_invoice', label: 'Invoice Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'bank_deposit_invoice', label: 'Bank Deposit', sortable: false, variant: 'light',
                        formatter: value => value ? 'Yes' : 'No' },  
                    { key: 'receipt_date_invoice',label: 'Receipt Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'comments_invoice', label: 'Comments', sortable: false ,variant: 'light'},
              
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
               
            }
        },
        computed: {
            filteredList() {
                return this.invoices.filter(invoice => {
                    return invoice.entity_for_invoice.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.invoices.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             async showMsgBoxReceipt() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to receipt the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.save()
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadInvoices(){
                const url = `${baseApiUrl}/invoicessearchdate/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&receipt=${this.receipt}`
                axios(url).then(res =>{
                     this.invoices = res.data
                      this.isBusy = false
                })

                this.loadInvoiceTotal()
                this.loadInvoiceOpen()
                this.loadInvoiceClosed()
            },
            alterModo() {
                    this.mode = 'save'
                    this.invoice = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadInvoices()              
                this.invoice = {}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/invoicesapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadInvoices()

                        })
                        .catch(showError)

           },
             async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/invoicescanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadInvoices()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.invoice.id ? 'put' : 'post'
                const id = this.invoice.id ? `/${this.invoice.id}` : ''

                this.invoice.user_id_invoice = this.user.id
                this.invoice.company_id_invoice = this.compan.id
                
                await axios[method](`${baseApiUrl}/invoices${id}`, this.invoice)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.invoice.id
                    axios.delete(`${baseApiUrl}/invoices/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadInvoice(invoice, mode = 'save') {
                this.mode = mode
                 if(invoice.date_invoice) invoice.date_invoice = this.formatDate(invoice.date_invoice)
                 if(invoice.due_date_invoice) invoice.due_date_invoice = this.formatDate(invoice.due_date_invoice)
                 if(invoice.receipt_date_invoice) invoice.receipt_date_invoice = this.formatDate(invoice.receipt_date_invoice)
                this.invoice = { ...invoice }
                this.$refs.searchFocus.focus();
     
            },
            setInvoice(invoice){
                 this.invoice = { ...invoice }
            },
            openModalReceipt(item) {
                this.invoice = {...item}
                this.$bvModal.show('modalReceipt')
            },
            loadEntitys(){
                const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.entitys = res.data.map(type => {
                        return { value: type.id, text: type.name_entity + ' - ' + type.cnpj_cpf }
                    })
                
                })
            },
            async loadInvoiceTotal() {
            this.total_plot = 0

                const url = `${baseApiUrl}/invoicessearchdatetotal/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}`
                await axios.get(url).then(res => {
                    this.total_plot = this.formatPrice(
                        res.data[0].portion_total
                    )
                })
            
             },
            async loadInvoiceOpen() {
            this.total_plot_open = 0

                const url = `${baseApiUrl}/invoicessearchdateopen/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}`
                await axios.get(url).then(res => {
                    this.total_plot_open = this.formatPrice(
                        res.data[0].portion_open
                    )
                })
            
             },
            async loadInvoiceClosed() {
            this.total_plot_closed = 0

                const url = `${baseApiUrl}/invoicessearchdateclosed/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}`
                await axios.get(url).then(res => {
                    this.total_plot_closed = this.formatPrice(
                        res.data[0].portion_closed
                    )
                })
            
             },
            loadUrl(item){
                window.open(item.url_file)
            },
            async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
             async getLastStorageFile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                    await axios(url).then(
                        (res) =>
                        (this.invoice = {
                            ...this.invoice,
                            storage_id_invoice: res.data.id,
                        })
                    );
            },    

        },
        mounted(){

                this.start_date = moment().format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadInvoices()
            this.loadEntitys()
            this.showTable = true
        }
}
</script>

<style>


    .invoice-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .invoice-search button{
        font-size: 0.75rem;
    }

     .invoice-search select{
        font-size: 0.75rem;
    }

    .invoice-search input{
        font-size: 0.75rem;
    }

     .invoice-search textarea{
        font-size: 0.75rem;
    }

    .invoice-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalReceipt {
        font-size: 0.75rem;
    }

    #modalReceipt button{
        font-size: 0.75rem;
    }

     #modalReceipt input{
        font-size: 0.75rem;
    }

      #modalReceipt select{
        font-size: 0.75rem;
    }

      #modalReceipt label{
        font-size: 0.75rem;
        color: black;
    }

    #modalFile {
    font-size: 0.75rem;
    }

    #modalFile button{
    font-size: 0.75rem;
    }


    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
